// Currency and number formatting helpers for Angadya.
// Uses Indian rupee formatting with lakh/crore convention.

export const fmtInr = (n, opts = {}) => {
  if (n == null || isNaN(n)) return "—";
  const val = Number(n);
  if (opts.compact) {
    if (Math.abs(val) >= 1e7) return `₹${(val / 1e7).toFixed(2)} Cr`;
    if (Math.abs(val) >= 1e5) return `₹${(val / 1e5).toFixed(2)} L`;
    if (Math.abs(val) >= 1e3) return `₹${(val / 1e3).toFixed(1)}K`;
    return `₹${Math.round(val).toLocaleString("en-IN")}`;
  }
  return `₹${Math.round(val).toLocaleString("en-IN")}`;
};

export const fmtInt = (n) => {
  if (n == null || isNaN(n)) return "—";
  return Math.round(Number(n)).toLocaleString("en-IN");
};

export const fmtPct = (n, digits = 1) => {
  if (n == null || isNaN(n)) return "—";
  const val = Number(n);
  const sign = val > 0 ? "+" : "";
  return `${sign}${val.toFixed(digits)}%`;
};

export const fmtShare = (n) => `${(n * 100).toFixed(1)}%`;

export const shortDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-IN", { month: "short", day: "numeric" });
};

export const monthLabel = (yyyymm) => {
  const [y, m] = yyyymm.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return d.toLocaleDateString("en-IN", { month: "short", year: "2-digit" });
};

export const initials = (name) => {
  if (!name) return "";
  return name.split(/\s+/).map((s) => s[0]).slice(0, 2).join("").toUpperCase();
};
